import { FC } from 'react';
import Router from '../routing/Router';

const Full: FC = () => {
	return <Router />;
	//return <ActivityRouter />;
};

export default Full;
